export const host = process.env.VUE_APP_API_MODULE_DOCUMENT_HOST

export const baseURL = host + '/api/v1/'
